import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;
// ---------------------------------------------------------------------
// Committee
// ---------------------------------------------------------------------
export const getCommittee = () => axios.get(`${API_BASE}/api/committee`);

export const addCommitteeMember = (formData) =>
  axios.post(`${API_BASE}/api/committee`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const updateCommitteeMember = (id, formData) =>
  axios.put(`${API_BASE}/api/committee/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const deleteCommitteeMember = (id) =>
  axios.delete(`${API_BASE}/api/committee/${id}`);

// ---------------------------------------------------------------------
// CSR Projects
// ---------------------------------------------------------------------
export const getCsrProjects = (category) =>
  axios.get(`${API_BASE}/api/csr-projects`, {
    params: category ? { category } : {},
  });

export const addCsrProject = (formData) =>
  axios.post(`${API_BASE}/api/csr-projects`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const updateCsrProject = (id, formData) =>
  axios.put(`${API_BASE}/api/csr-projects/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const deleteCsrProject = (id) =>
  axios.delete(`${API_BASE}/api/csr-projects/${id}`);

// ---------------------------------------------------------------------
// CSR Documents (reports shown on the /csr page, if you use them there)
// ---------------------------------------------------------------------
export const getCsrDocuments = (category) =>
  axios.get(`${API_BASE}/api/csr-documents`, {
    params: category ? { category } : {},
  });

export const addCsrDocument = (formData) =>
  axios.post(`${API_BASE}/api/csr-documents`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const updateCsrDocument = (id, formData) =>
  axios.put(`${API_BASE}/api/csr-documents/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const deleteCsrDocument = (id) =>
  axios.delete(`${API_BASE}/api/csr-documents/${id}`);

// ---------------------------------------------------------------------
// Policies (HR-Policy / CSR Policy / Annual Return, shown on /policies page)
// ---------------------------------------------------------------------
export const getPolicies = (category) =>
  axios.get(`${API_BASE}/api/policies`, {
    params: category ? { category } : {},
  });

export const addPolicy = (formData) =>
  axios.post(`${API_BASE}/api/policies`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const updatePolicy = (id, formData) =>
  axios.put(`${API_BASE}/api/policies/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const deletePolicy = (id) =>
  axios.delete(`${API_BASE}/api/policies/${id}`);

// ---------------------------------------------------------------------
// Policy Categories (custom categories for the Policies & Annual Returns
// admin page — persisted on the server, not just in the browser)
// ---------------------------------------------------------------------
export const getPolicyCategories = () =>
  axios.get(`${API_BASE}/api/policy-categories`);

export const addPolicyCategory = (name) =>
  axios.post(`${API_BASE}/api/policy-categories`, { name });

export const deletePolicyCategory = (id) =>
  axios.delete(`${API_BASE}/api/policy-categories/${id}`);